import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat/Observable';
import { GenericService } from 'src/app/commons/generic.service';
import { SistemaDocumento } from 'src/app/model/sistemaDocumento';

@Injectable({
  providedIn: 'root'
})
export class SistemaDocumentoService extends GenericService {

  private relativePath = 'api/documentos';
  resultadoChamado: Observable<string>;

  constructor(http: HttpClient) {
      super(http);
  }
  
  obterListaDocumentos(idSistemas: Array<number>,idTipoSolicitacaos: Array<number>,): Observable<Array<SistemaDocumento>> {
    return this.http.get<Array<SistemaDocumento>>(this.url + this.relativePath + "/findAll-documentosSistema-by-IdSistema/" +idSistemas +"/by-IdTipoSolicitacao/" + idTipoSolicitacaos );
  }
}
